// src/v2/components/GDS/Button/index.tsx

import React from 'react';
import { Button } from 'pepsico-ds';
import type { IButtonProps } from 'pepsico-ds/dist/lib/Atoms/Button';

export interface ButtonWrapperProps extends IButtonProps {}

const ButtonWrapper: React.FC<ButtonWrapperProps> = ({
  text,
  children,
  ...rest
}) => {
  return <Button {...rest}>{text || children}</Button>;
};

export default ButtonWrapper;
